export const checkIsTheCallerComplete = () => {
  // There is no required fields in this section at the moment
  return true
}
